module.exports = __webpack_public_path__ + "static/media/card-food-container@2x.82fb3374.png";